import toast from "react-hot-toast";
import { loginApiUrl } from "../constants/common";
import StatusCodes from "../constants/StatusCodes";
import { AUTH_ROUTES } from "../routes";
import useAuthStore from "../store/Auth";
import { t } from "i18next";
import { getOrRefreshAuthToken } from "./getOrRefreshAuthToken";

export const handleFetchError = async (
  res: Response,
  url: string,
  isReturnBlob = false,
  retryRequest?: () => Promise<Response>,
  hasRetried = false
): Promise<any> => {
  const reset = useAuthStore.getState().reset;

  if (res.status === StatusCodes.RATE_LIMIT) {
    toast.error(t("tooManyRequestsTryAgainLater"));
    return;
  }

  if (res.status === StatusCodes.FORBIDDEN) {
    toast.error(t("notAuthorizedToPerformAction"));
    return;
  }

  if (
    res.status >= StatusCodes.BAD_REQUEST &&
    res.status < StatusCodes.CONNECTION_TIMED_OUT
  ) {
    if (
      res.status === StatusCodes.UNAUTHORIZED &&
      url !== loginApiUrl &&
      !hasRetried
    ) {
      try {
        await getOrRefreshAuthToken();

        if (retryRequest) {
          const retryRes = await retryRequest();
          return handleFetchError(
            retryRes,
            url,
            isReturnBlob,
            retryRequest,
            true
          );
        }
      } catch (err) {
        toast.error(t("sessionExpiredPleaseLoginAgain"));
      }

      localStorage.clear();
      reset();
      window.location.href = AUTH_ROUTES.LOGIN;
    } else {
      await res.clone().json();
    }

    const response = await res.clone().json();
    const errRes = {
      ...response,
      status: res.status,
    };
    throw errRes;
  }

  if (isReturnBlob) {
    return res.blob();
  }

  return res.json();
};